/* eslint-disable import/no-unresolved */
import { MatxLoadable } from "matx";

const LocationList = MatxLoadable({
  loader: () => import("../views/locations/"),
});

const LocationDetail = MatxLoadable({
  loader: () => import("../views/locations/locationDetail"),
});

const LocationGroup = MatxLoadable({
  loader: () => import("../views/locations/locationGroup"),
});

const locationRoutes = [
  {
    path: "/locations/dashboard",
    component: LocationList,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/locations/group",
    component: LocationGroup,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/locations/:id",
    component: LocationDetail,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default locationRoutes;
